// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles_back__3lmnu {\n  display: flex;\n  align-items: baseline; }\n\n.styles_backImg__OLbrT {\n  cursor: pointer; }\n\n.styles_submitButton__1XVG3 {\n  width: 342px; }\n\n.styles_title__1d5Cj {\n  font-family: Roboto-Bold;\n  font-size: 24px;\n  line-height: 28px;\n  color: #3e3e3e;\n  margin-left: 20px;\n  margin-bottom: 22px; }\n\n.styles_profile__2KWkx {\n  height: 606px;\n  min-width: 460px;\n  padding: 30px;\n  background: #ffffff; }\n\n.styles_field__2Wg_M {\n  margin-bottom: 40px; }\n  .styles_field__2Wg_M .styles_text__1rzfk {\n    font-size: 14px;\n    line-height: 16px;\n    color: #9b9b9b;\n    margin-bottom: 30px; }\n  .styles_field__2Wg_M .styles_subtext__27MzR {\n    width: 342px;\n    font-size: 14px;\n    line-height: 16px;\n    color: #3e3e3e; }\n\n.styles_error__1mSwr {\n  font-size: 12px;\n  line-height: 16px;\n  color: #f44336;\n  margin-bottom: 16px; }\n", ""]);
// Exports
exports.locals = {
	"back": "styles_back__3lmnu",
	"backImg": "styles_backImg__OLbrT",
	"submitButton": "styles_submitButton__1XVG3",
	"title": "styles_title__1d5Cj",
	"profile": "styles_profile__2KWkx",
	"field": "styles_field__2Wg_M",
	"text": "styles_text__1rzfk",
	"subtext": "styles_subtext__27MzR",
	"error": "styles_error__1mSwr"
};
module.exports = exports;
